import React from 'react'
import styles from './Breadcrumb.module.scss'
import { paths } from 'components/LP/LP202407/pages/ECS/Top'

export const Breadcrumb: React.FC<{ paths: paths }> = ({ paths }) => {
  const isLast = (index: number) => index === paths.length - 1
  return (
    <nav aria-label="breadcrumb" className={styles.breadcrumb}>
      <ul className={styles.breadcrumb_list}>
        {paths.map(({ name, url }, index) => {
          return (
            <>
              <li key={name} className={styles.breaditem}>
                {name !== 'Services' && !isLast(index) ? (
                  <a href={url}>{name}</a>
                ) : (
                  <span className={styles.none}>{name}</span>
                )}
              </li>
              {!isLast(index) && (
                <svg
                  className={styles.breaditem_svg}
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="chevron">
                    <path
                      id="Vector"
                      d="M4.14656 3.55754L6.43656 5.85254L4.14656 8.14754L4.85156 8.85254L7.85156 5.85254L4.85156 2.85254L4.14656 3.55754Z"
                      fill="currentColor"
                    />
                  </g>
                </svg>
              )}
            </>
          )
        })}
      </ul>
    </nav>
  )
}
